/**
 * Controller for AppManager
 */
define('controllers/myservices/rollout.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('rolloutCtrl', ['$q', '$scope', '$location','$stateParams','$state',
        function ($q, $scope, $location,$stateParams, $state) {
            var serviceItem = $stateParams.serviceItem;
            var product = $stateParams.product;
            var Model = $scope.Model = {};
            if(!serviceItem || AUI.BaseJSUtil.contains(window.systemParaConf.notAllowSerItem,serviceItem)){
                $state.go('home', {}, {reload:true});
            }else{
                if(product){
                    Model.productName = product.prodName;
                }
                var urlKey = angular.copy(serviceItem);
                if( urlKey == '30'){
                    urlKey = "30-14";
                    if(product && product.isUpdate){
                        urlKey =  '30' +  "-" + product.prodType;
                    }else if(product && product.selected  && product.selected.prodType){/*针对返回上一步的情况*/
                        urlKey =  '30' + "-" + product.selected.prodType;
                    }
                }
                Model.stepsConf = mainCons.myserviceRollout.stepsConfByServiceItem[urlKey];
                Model.customClass = 'proper-height-hide-scrollbar-myservices';
                if($location.url() =='/rollout'){
                    $state.go('rollout.selPkg',{serviceItem:serviceItem,product:product});
                }
                $scope.$watch("prodType",function(n,o){
                    if(typeof n != 'undefined' && serviceItem == 30){
                            Model.stepsConf = mainCons.myserviceRollout.stepsConfByServiceItem["30-" + n];
                    }
                });
            }

        }]);
});
